//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { staticType } from "./config"
import Xcell from '@/components/common/x-cell'
import bridgeApi from "sy-bridge";

export default {
    name:'instructionProtocol',
    data(){
        return {
            selectFlag:false,
            modeShow:false,
            modeTitle:'',
            modeList:[],
            pdfList: [],
            pdfReadStatus: false
          }
    },
    props: {
        type:{
           type: String,
            default() { return 'green' } 
        },
        staticName:{ //埋点配置信息
            type: String,
            default() { return 'proinfo' } 
        },
        materielMap:{ //协议内容
            type: Array,
            default() { return  [] } 
        },
        defaultChecked:{ // 默认选中
            type: Boolean,
            default:false,
        },
        size11:{ //字号为11
            type: Boolean,
            default:false,
        }
    },
    watch: {
        materielMap: {
            handler(val){
               if(Array.isArray(val) && val.length){
                this.onReset();
                val.forEach(n=>{
                    if(Array.isArray(n.materielList) && n.materielList.length){
                        n.materielList.forEach(m=>{
                            this.pdfList.push({
                                title: m.fileName,
                                pdf: m.shortUrl
                            })
                        })
                    }
                })
               }
            },
            deep: true,
            immediate: true
        }
    },
    components:{
        Xcell
    },
    mounted(){
        window.$eventBus.on('closePdf',({status})=>{
            this.$emit('completed')
            if(status){
                this.selectFlag = true; // 勾选
                this.pdfReadStatus = true; //已阅读完
            }
        })
    },
    methods:{
        // 判断是否勾选
        checkSelectFlag(){
            return new Promise((resolve,reject)=>{
                 this.selectFlag?resolve(true):resolve(false)
            })
        },
        // 协议勾选框点击
        selectClick(){
            if(!this.selectFlag && !this.pdfReadStatus){
                this.$emit('handle')
                window.$eventBus.emit('openPdf', {
                    pdfList: this.pdfList,
                    isSubmit: 0
                });
                return;
            }

            if(this.selectFlag){
                staticType[this.staticName].uncheck()
            }else{
                staticType[this.staticName].check()
            }
            this.selectFlag = !this.selectFlag
            this.$emit('input', this.selectFlag)

        },
        // 展示弹框
        treatyClick(item){
            if(item.materielList.length > 1){
                this.modeShow = true;
                this.modeTitle = item.fileCategoryDesc
                this.modeList = item.materielList
            }else{
                this.cellClick(item.materielList[0])
            }
            
            staticType[this.staticName].treatyshow()

            
        },
        cellClick(item){
            this.modeShow = false;
            if(item.shortUrl && this.pdfList.length){
                this.$emit('handle')
                window.$eventBus.emit('openPdf', {
                    pdfList: this.pdfList,
                    isSubmit: 0
                });
            }else{
               this.$toast("未获取到pdf地址");
            }
            
        },
        onReset(){
            this.pdfList = [];
            this.selectFlag = false;
            this.pdfReadStatus = false;
        },
    },
}
